/**
 * Nesse arquivo vamos criar algumas funções e constantes para definir campos obrigatórios
 * na compra com base no ERP utilizado.
 *
 * Isso será substituido futuramente por uma API que irá retornar essas informações.
 *
 * por enquanto vamos criar um mock para simular essa API, mas com os valores reais.
 * No futuro, podemos substituir esse arquivo pelas requests diretamente.
 */

const ERP_CAMPOS_HIDDEN_MAP = {
  CASA_SHOPPING: {
    camposItens: ['centroCusto'],
  },
};

const ERP_CAMPOS_READONLY_MAP = {
  SENIOR_MEGA: {
    campos: ['centroCusto', 'projeto'],
    camposItens: ['centroCusto', 'projeto', 'cadastrosAdicionais'],
  },
};

const ERP_CAMPOS_OBRIGATORIOS_MAP = {
  SANKHYA: {
    campos: ['modoPagamento'],
  },
  M8: {
    campos: ['modoPagamento'],
  },
  PROJEDATA: {
    campos: ['modoPagamento', 'transportadora', 'tipoNotaEntrada'],
    camposItens: ['tipoNotaEntrada'],
  },
  SENIOR_TEIXEIRA: {
    campos: ['modoPagamento', 'centroCusto'],
    camposItens: ['centroCusto'],
  },
  NEO: {
    campos: ['tipoNotaEntrada'],
    camposItens: ['tipoNotaEntrada'],
  },
  TOTVS: {
    campos: ['modoPagamento'],
  },
  LM: {
    campos: ['modoPagamento'],
  },
  USEALL: {
    campos: ['modoPagamento'],
  },
  USEALL_SETUP: {
    campos: ['modoPagamento', 'projeto', 'centroCusto'],
    camposItens: ['projeto', 'centroCusto'],
  },
  FOCCO: {
    campos: ['centroCusto'],
    camposItens: ['centroCusto'],
  },
  USEALL_PROCER: {
    campos: ['centroCusto', 'modoPagamento'],
    camposItens: ['centroCusto'],
  },
  SENIOR_MEGA: {
    campos: ['centroCusto', 'projeto', 'modoPagamento'],
    camposItens: ['centroCusto', 'projeto'],
  },
  CASA_SHOPPING: {
    campos: ['centroCusto'],
  },
  NEO_GABRIELLA: {
    campos: ['tipoNotaEntrada'],
    camposItens: ['tipoNotaEntrada'],
  },
};

/**
 * Retorna uma promise para simular uma request e ficar mais fácil de lidar com isso depois
 * @param erpCamposIntegracao
 * @returns {Promise<Awaited<*>|Awaited<null>>}
 */
const getCamposObrigatorios = async (erpCamposIntegracao) => {
  const camposObrigatorios = ERP_CAMPOS_OBRIGATORIOS_MAP[erpCamposIntegracao];
  if (!camposObrigatorios) {
    return Promise.resolve(null);
  }
  return Promise.resolve(camposObrigatorios);
};

/**
 * Retorna uma promise para simular uma request e ficar mais fácil de lidar com isso depois
 * @param erpCamposIntegracao
 * @returns {Promise<Awaited<*>|Awaited<null>>}
 */
const getCamposReadonly = async (erpCamposIntegracao) => {
  const camposReadonly = ERP_CAMPOS_READONLY_MAP[erpCamposIntegracao];
  if (!camposReadonly) {
    return Promise.resolve(null);
  }
  return Promise.resolve(camposReadonly);
};

/**
 * Retorna uma promise para simular uma request e ficar mais fácil de lidar com isso depois
 * @param erpCamposIntegracao
 * @returns {Promise<Awaited<*>|Awaited<null>>}
 */
const getCamposHidden = async (erpCamposIntegracao) => {
  const camposHidden = ERP_CAMPOS_HIDDEN_MAP[erpCamposIntegracao];
  if (!camposHidden) {
    return Promise.resolve(null);
  }
  return Promise.resolve(camposHidden);
};

export default {
  getCamposObrigatorios,
  getCamposReadonly,
  getCamposHidden,
};
